<template>
  <Content :button-create-show="true">
    <template #body>
      <Table
        v-if="!loading"
        :columns="columns"
        :options="columnsOptions"
        :method-fetch-data="methods.fetchData"
        :method-delete-row="methods.deleteRow"
      >
        <template v-slot:controls="{ row }">
          <div class="">
            <router-link :to="`edit/${row.id}`">
              <el-button icon="el-icon-edit" size="mini"
                >Редактировать</el-button
              >
            </router-link>
            <!-- <el-button icon="el-icon-edit" size="mini" @click="isGlobal(row.id)"
              >Сделать глобальным</el-button
            > -->
          </div>
        </template>
      </Table>
    </template>
  </Content>
</template>

<script>
import Content from "@/layout/Content";
import Table from "@/components/Table";

import {
  getRegions,
  deleteRegions as deleteRow,
  postIsGlodalRegion,
} from "@/api/regions";

const columnsOptions = {
  sortable: "",
  controls: {
    width: 300,
  },
  edit: true,
  id: "id",
  delete_row: {
    buttonName: "Удалить",
    confirm: true,
  },
};

const columns = [
  {
    prop: "id",
    label: "ID",
    notDefaultSort: true,
  },
  {
    prop: "name",
    label: "Название региона",
  },
  // {
  //   prop: "is_global",
  //   label: "Глобальный",
  //   type: "bool",
  // },
  {
    prop: "macroregion_name",
    label: "В макрорегионе",
  },
];

const midFunc = async (query, params) => {
  const data = await getRegions(query, params);
  const regions = data.regions.map((el) => {
    return {
      ...el,
      macroregion_name: el.macroregion?.name,
      macroregion_id: el.macroregion?.id,
    };
  });
  regions.sort((a, b) => {
    return b.is_global ? 1 : -1;
  });
  return regions;
};

export default {
  components: {
    Content,
    Table,
  },
  data() {
    return {
      loading: false,
      columnsOptions: columnsOptions,
      columns: columns,
      methods: {
        fetchData: midFunc,
        deleteRow,
      },
    };
  },
  methods: {
    async isGlobal(id) {
      this.loading = true;
      await postIsGlodalRegion(id);
      this.$message({
        type: "success",
        message: "Глобальный регион изменен",
      });
      this.loading = false;
    },
  },
};
</script>
